var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkEmailRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M166.154-720 480-520l313.846-200H166.154Zm6.155 539.999q-29.827 0-51.067-21.241-21.241-21.24-21.241-51.067v-455.382q0-29.827 21.241-51.067 21.24-21.241 51.067-21.241h615.382q29.827 0 51.067 21.241 21.241 21.24 21.241 51.067v211.539q0 12.75-8.629 21.374-8.629 8.625-21.384 8.625-12.756 0-21.371-8.625Q800-483.402 800-496.152v-166.157L499.461-469.924q-3.384 2.384-19.461 5.615-5 0-9.923-1.308-4.923-1.307-9.538-4.307L160-662.309v410q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462H385q12.75 0 21.375 8.629Q415-222.743 415-209.987q0 12.755-8.625 21.37-8.625 8.616-21.375 8.616H172.309ZM480-421.155ZM480-520Zm0 57.691Zm148.769 283.387 205.692-205.693q8.308-8.307 20.885-8.5 12.576-.192 21.268 8.5t8.692 21.076q0 12.385-8.692 21.077L654.076-119.924q-10.846 10.846-25.307 10.846-14.462 0-25.308-10.846L493.692-229.693q-8.307-8.307-8.5-20.884-.192-12.577 8.5-21.269 8.692-8.692 21.077-8.692 12.384 0 21.076 8.692l92.924 92.924Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmailRead);
export default __webpack_public_path__ + "static/media/mark-email-read.c413d2bdd2d82d530507a39fb466c2ca.svg";
export { ForwardRef as ReactComponent };